import { Component, OnInit, Optional, Inject, Output, EventEmitter, ViewChild  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ITimeUpdateEvent, NgWaveformComponent, IRegionPositions } from 'ng-waveform';

@Component({
  selector: 'app-audio-player-popup',
  templateUrl: './audio-player-popup.component.html',
  styleUrls: ['./audio-player-popup.component.scss']
})
export class AudioPlayerPopupComponent implements OnInit {
  audioURL: string; /// /Webviewer/assets/audio/audio.wav
  nodeName: string;
  message: string;
  title: string;
  baseUrl: string;
  url: string;
  isPlaying: boolean = false;

  @ViewChild('waveformAudio', { static: false }) waveform: NgWaveformComponent;

  constructor(private http: HttpClient, public dialogBox: MatDialogRef<AudioPlayerPopupComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.baseUrl = environment.urlAddress + '/api/';
    debugger;
    //alert(data.audioURL);
    this.audioURL = data.audioURL;//Node ID
    this.nodeName = data.nodeName;
    this.message = data.message;
    //console.log(this.message);

  }

  ngOnInit() {

    
  }

  togglePlayback() {    
    this.isPlaying = !this.isPlaying;
    if (this.isPlaying) {
      // Start playback
      this.onAudioPlay();
    } else {
      // Pause playback
      this.onAudioPause();
    }
  }

  onTimeUpdate(event) {
    debugger;
    if (event.progress >= 100)
      this.isPlaying = false;
    //console.log(event.progress);
  }

  onAudioPlay() {    
    //this.audio = new Audio('/Webviewer/assets/audio/audioTest.wav');
    //this.audio.play();    
    this.waveform.play();    
  }

  onAudioPause() {
    //this.audio.pause();
    this.waveform.pause();
  }

  onAudioStop() {
    //this.audio.pause();
    //this.audio.currentTime = 0;
    // Seek to the start of the audio
        
  }

  Close() {
    this.dialogBox.close();
  }


}
